.dummyInput {
  position: absolute;
  top: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  font-size: 16px;
  opacity: 0.01;
}
